<template>
  <component :is="tag">
    <template v-if="wrapperElementTag">
      <Component
        :is="wrapperElementTag"
        v-for="({ _uid, component, ...props }, index) in visibleBlocks"
        :key="_uid"
        v-bind="wrapperElementAttrs[index]"
      >
        <Component
          :is="component"
          v-editable="props"
          v-bind="props"
        />
      </Component>
    </template>
    <template v-else>
      <Component
        :is="component"
        v-for="{ _uid, component, ...props } in visibleBlocks"
        :key="_uid"
        v-editable="props"
        v-bind="props"
      />
    </template>
  </component>
</template>

<script>
import components from '@poetix-aliases/project-content-blocks'

export default {
  name : 'ContentBlockList',
  components,
  props: {
    blocks: {
      required: true,
      type    : Array,
    },
    tag: {
      type   : String,
      default: 'div',
    },
    wrapperElementTag: {
      type   : String,
      default: null,
    },
    wrapperElementAttrs: {
      type   : Array,
      default: () => [],
    },
  },
  computed: {
    existingBlocks () {
      return this.blocks.filter((block) => block.component in components)
    },
    visibleBlocks () {
      return this.existingBlocks.filter((block) => !block.hidden)
    },
  },
  updated () {
    this.$emit('updated')
  },
}
</script>
